import React from "react";
import { Route } from "react-router-dom";
import BuyerHomepage from "../../screens/buyer/BuyerHomepage";
import BuyerMain from "../../screens/buyer/BuyerMain";
import PostRequirements from "../../screens/buyer/PostRequirement";
import AddRequirement from "../../screens/buyer/AddRequirement";
import TraceCrop from "../../screens/buyer/TraceCrop";
import AvailableCommodities from "../../screens/buyer/AvailableCommodities";
import DetailedAvailableCommodity from "../../screens/buyer/DetailedAvailableCommodity";
import FarmerCommodity from "../../screens/buyer/FarmerCommodity";
import BidsAndTrades from "../../screens/buyer/BidsAndTrades";
import BidDetailedView from "../../screens/buyer/BidDetailedView";
import RequirementDetailedView from "../../screens/buyer/RequirementDetailedView";
import Programs from "../../screens/programs/Programs";
import CreateProgram from "../../screens/programs/CreateProgram";
import EditProgram from "../../screens/programs/EditProgram";
import CreateProgramInput from "../../screens/programs/CreateProgramInput";
import UploadProgramInputs from "../../screens/programs/UploadProgramInputs";
import EditProgramInput from "../../screens/programs/EditProgramInput";
import CreateProgramInputTask from "../../screens/programs/CreateProgramInputTask";
import BuyerProfile from "../../screens/buyer/BuyerProfile";
import DecarbonizationBuyer from "../../screens/buyer/DecarbonizationBuyer";
import MarketPrices from "../../screens/market_prices/MarketPrices";
import AddCSV from "../../screens/buyer/AddCSV";
import BuyerMarketPlace from "../../screens/buyer/BuyerMarketPlace";

export const buyerRoutes = [
  <Route key="buyer-home" path="/" element={<BuyerHomepage />} />,
  <Route key="service-buyer" path="/service/buyer" element={<BuyerMain />} />,
  <Route
    key="buyer-requirement"
    path="/buyer/requirement"
    element={<PostRequirements />}
  />,
  <Route
    key="buyer-add-requirement"
    path="/buyer/add-requirement"
    element={<AddRequirement />}
  />,
  <Route key="buyer-trace" path="/buyer/trace" element={<TraceCrop />} />,
  <Route
    key="buyer-available-commodities"
    path="/buyer/view-available-commodities"
    element={<AvailableCommodities />}
  />,
  <Route
    key="buyer-available-commodities-fpo"
    path="/buyer/view-available-commodities/fpo"
    element={<DetailedAvailableCommodity />}
  />,
  <Route
    key="buyer-available-commodities-farmer"
    path="/buyer/view-available-commodities/:commodityId/farmer/:farmerId"
    element={<FarmerCommodity />}
  />,
  <Route
    key="buyer-bids-trades"
    path="/buyer/bids-trades"
    element={<BidsAndTrades />}
  />,
  <Route
    key="buyer-bid-detail"
    path="/buyer/bids-trades/bid"
    element={<BidDetailedView />}
  />,
  <Route
    key="buyer-requirement-detail"
    path="/buyer/bids-trades/requirement"
    element={<RequirementDetailedView />}
  />,
  <Route key="buyer-programs" path="/programs" element={<Programs />} />,
  <Route
    key="buyer-create-program"
    path="/programs/program/create"
    element={<CreateProgram />}
  />,
  <Route
    key="buyer-edit-program"
    path="/programs/program/:programId"
    element={<EditProgram />}
  />,
  <Route
    key="buyer-create-program-input"
    path="/programs/:programId/add-input"
    element={<CreateProgramInput />}
  />,
  <Route
    key="buyer-upload-program-inputs"
    path="/programs/:programId/upload-inputs"
    element={<UploadProgramInputs />}
  />,
  <Route
    key="buyer-edit-program-input"
    path="/programs/program-input/:programInputId"
    element={<EditProgramInput />}
  />,
  <Route
    key="buyer-create-program-input-task"
    path="/programs/program-input/:programInputId/add-task"
    element={<CreateProgramInputTask />}
  />,
  <Route
    key="buyer-details"
    path="/buyer/details"
    element={<BuyerProfile />}
  />,
  <Route
    key="buyer-decarbonization"
    path="/buyer/decarbonization"
    element={<DecarbonizationBuyer />}
  />,
  <Route
    key="buyer-market-price"
    path="/market-price"
    element={<MarketPrices />}
  />,
  <Route key="buyer-add-csv" path="/buyer/add-csv" element={<AddCSV />} />,
  <Route
    key="buyer-market-place"
    path="/buyer/market-place"
    element={<BuyerMarketPlace />}
  />,
];
